module.exports = __webpack_public_path__ + "static/media/banner-aviso-numero-whats.5ff3ac4b.png";